import { render, staticRenderFns } from "./flags-icon.vue?vue&type=template&id=bf234904"
import script from "./flags-icon.vue?vue&type=script&lang=js"
export * from "./flags-icon.vue?vue&type=script&lang=js"
import style0 from "./flags-icon.vue?vue&type=style&index=0&id=bf234904&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports